import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-konzept',
  templateUrl: './konzept.component.html',
  styleUrls: ['./konzept.component.scss']
})
export class KonzeptComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  selectPage(n:number){
    this.page=n
  }

  public page=1;

}
